import { createApp } from 'vue'
import AlbumsShowApp from '../pages/albums-show/AlbumsShowApp.vue'

// Turbo keeps the JS context and its event listeners across page visits,
// and a `type="module"` entrypoint is evaluated only once. An entrypoint must
// therefore mount only on its own page: check the layout's `body`
// `data-controller` / `data-action` and a dedicated mount element id (plus a
// `data-vite-entry` marker). Never mount on a generic id such as `#vue`, which
// other screens also render (albums#new/#edit, line_map#show,
// collabo_line_map#show, ...) - doing so hijacks that screen's instance after
// a Turbo visit.
//
// Apply the same page-scoping rule to every Vite entrypoint added in Step 3
// and later.
const MOUNT_ID = 'albums-show-app'
const ENTRY = 'albums-show'

let app = null

function mount() {
  const body = document.body
  if (body.dataset.controller !== 'albums' || body.dataset.action !== 'show') return

  const el = document.getElementById(MOUNT_ID)
  if (!el || el.dataset.viteEntry !== ENTRY) return

  unmount()

  const album = el.dataset.props ? JSON.parse(el.dataset.props) : {}

  app = createApp(AlbumsShowApp, {
    albumId: el.dataset.id,
    album,
    user: album.user || null,
  })
  app.mount(el)
}

function unmount() {
  if (app) {
    app.unmount()
    app = null
  }
}

document.addEventListener('turbo:load', mount)
document.addEventListener('turbo:before-visit', unmount)
window.addEventListener('beforeunload', unmount)

// When this module is evaluated after Turbo has already dispatched its
// initial `turbo:load` (e.g. loaded on demand), mount right away.
if (document.readyState === 'complete') mount()
